//@ts-ignore
// @ts-nocheck
import {
  applySnapshot,
  flow,
  getEnv,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { Availability, emptyAvailability } from "../schedule";

const getHourlyRates = (monthlyPrices) => {
  if (Object.values(monthlyPrices).every(Boolean)) {
    let oneStudentPrice = monthlyPrices["1 student"];
    let twoStudentsPrice = monthlyPrices["2 students"];
    let hourlyRate = Math.round(oneStudentPrice / 240) * 10;
    let hourlyDiscount = Math.round(
      (twoStudentsPrice / oneStudentPrice - 1) * 100,
    );

    return { hourlyRate, hourlyDiscount };
  } else return { hourlyRate: 0, hourlyDiscount: 50 };
};

const SubjectStore = types
  .model({
    name: types.string,
    price: types.optional(types.number, 0),
  })
  .actions((self) => {
    return {
      updatePrice(price) {
        self.price = price;
      },
    };
  });

const TutorPricingStore = types
  .model("TutorPricing", {
    subjects: types.optional(types.array(SubjectStore), []),
    currency: types.optional(types.string, "₦"),
    availability: types.optional(Availability, emptyAvailability),
    isLoading: types.optional(types.boolean, false),
    monthlyPricingStore: types.optional(types.array(SubjectStore), [
      { name: "1 student", price: 0 },
      { name: "2 students", price: 0 },
    ]),
    currentSubject: types.optional(types.string, ""),
    discount: types.optional(types.number, 0),
    level: types.optional(types.string, "regular"),
    lessonsTaught: types.optional(types.number, 0),
    isNewTutor: types.optional(types.boolean, false),
  })
  .views((self) => {
    return {
      get monthlyPrices() {
        let result = {};
        self.monthlyPricingStore.forEach((r) => {
          result[r.name] = r.price;
        });
        return result;
      },
      get subjectPrices() {
        let result = {};
        self.subjects.forEach((subject) => {
          result[subject.name] = subject.price;
        });
        return result;
      },
      get tutorSubjects() {
        return self.subjects.map((o) => o.name);
      },
      get newTutor() {
        //Todo
        return self.lessonsTaught === 0 && self.isNewTutor;
      },
      get isPremium() {
        return self.level === "premium";
      },
      get commission() {
        return this.isPremium ? 75 : 70;
      },
      getEarning(amount = 0) {
        return (amount * self.commission) / 100;
      },
      get discountForExtraStudents() {
        return getHourlyRates(this.monthlyPrices).hourlyDiscount;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    const onSubmit = flow(function* onSubmit(step) {
      const data = {
        hourlyRates: self.subjectPrices,
        discountForExtraStudents: self.discountForExtraStudents,
        newTutorDiscount: self.discount,
      };
      self.isLoading = true;
      try {
        let result = yield adapter.savePricingInfo(
          data,
          getSnapshot(self.availability),
        );
        self.isLoading = false;
        if (step) {
          adapter.clearStorage();
        }
      } catch (error) {
        self.isLoading = false;
        throw error;
      }
    });
    return {
      setAvailability(day, times) {
        let previous = getSnapshot(self.availability);
        let newAvailability = { ...previous, [day]: times };
        applySnapshot(self.availability, newAvailability);
        // self.availability = newAvailability;
      },
      onSubmit,
      initializeTutorInfo(tutorData) {
        applySnapshot(self, {
          ...getSnapshot(self),
          subjects: tutorData.subjects.map((o) => ({ name: o })),
          availability: tutorData.availability,
          level: tutorData.level,
          lessonsTaught: tutorData.lessonsTaught,
          isNewTutor: tutorData.isNewTutor,
        });
      },
      setMonthlyPrices(obj) {
        self.monthlyPricingStore.forEach((o) => {
          o.updatePrice(obj[o.name]);
        });
      },
      setSubjectPrices(obj) {
        self.subjects.forEach((o) => {
          o.updatePrice(obj[o.name]);
        });
      },
      setLoading(value) {
        self.isLoading = value;
      },
      setDiscount(dixcount) {
        self.discount = dixcount;
      },
    };
  });

export default TutorPricingStore;
